import ReactPopover from "react-popover";
import { menuRow, MenuRowProps } from "styles/rowStyles";
import styled from "styled-components";

export const DropdownMenuWrapper = styled(ReactPopover)`
  min-width: max-content;
  z-index: 10;

  .Popover-tipShape {
    fill: ${({ theme }) => theme.dropdownBg};
  }
`;

export const DropdownMenuBody = styled.div`
  filter: drop-shadow(0 2px 8px ${({ theme }) => theme.shadowColor});
  background-color: ${({ theme }) => theme.dropdownBg};
  border: 1px solid ${({ theme }) => theme.divider};
  border-radius: 2px;
  min-width: 150px;
  overflow: hidden;
`;

interface DropdownMenuItemStyledProps extends MenuRowProps {
  disabled?: boolean;
}

export const DropdownMenuItemStyled = styled.button<DropdownMenuItemStyledProps>`
  ${menuRow}
  padding: 10px 16px;
  border-radius: 0;
  font-size: 14px;
  white-space: nowrap;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.divider};
  }
`;

export const TriggerWrapper = styled.div`
  display: inline-block;
`;
